<template>
  <div>
    <image-cropper :imgUrl="'https://d8dnjyv38gzts.cloudfront.net/watermarked/1654789752778MtObg.png'"/>
  </div>
</template>
 <style>
    img {
        display: block;

        /* This rule is very important, please don't ignore this */
        max-width: 100%;
    }
</style>

<script>
import service from "./../../service";
import Router from "vue-router";
import { isMobile } from "mobile-device-detect";
import Config from "../../config";
import axios from 'axios'
import ImageCropper from '../ImageCropper.vue'
//import VueCropper from "vue-cropperjs"

export default {
  name: "Login",
  data: function() {
    return {      
      isMobileScreen: isMobile,
      file: ''
    };
  },
  components: { ImageCropper },
  computed: {
    templateName() {
      return localStorage.templateName;
    }
  },
  methods: {
    test: function() {
      
    },
    onFileInputChanged(event) {
      this.file = this.$refs.file.files[0];
      setTimeout(() => {
        this.uploadFiles();
      }, 5000);
    },
    fazerIsso() {
      fetch("/result.json").then((response => {
        response.text().then(text => {
          service.saveExpressTemplateFromText(text).then(result => console.log(result));
        })
      }))
    },
    uploadFiles() {
      alert("vou subir - axios");

      this.loading = true;

      var formData = new FormData();

      
      formData.append("file", this.file);

      const baseURL = Config.BASE_API_URL;

      let options = {
        headers: {
          "Conectados-Auth": localStorage.sessionId,
          "Content-Type": 'multipart/form-data'
        },
        method: "POST",
        body: formData,
        bypassInterceptor: true
      };

      var vm = this;

      axios.post(baseURL + "upload-file",
        formData,
        {
          headers: {
            "Conectados-Auth": localStorage.sessionId
              //'Content-Type': 'multipart/form-data'
          }
        }
      ).then(function(){
        alert('SUCCESS!!');
      })
      .catch(function(e){
        alert('FAILURE!! - ' + (e ? JSON.stringify(e) : "No details"));
      });
      return;
      /*setTimeout(function() {
        console.log(options);
        fetch(baseURL + "upload-file", options).then(function(response) {
          if (response) {
            response.json().then((result) => {
              alert(JSON.stringify(result));
            })
            
          } else {
            alert("Houve um problema com seu upload :(. Tente novamente mais tarde!");
          }
        });
      }, 3000)
      */
    }
  },
  mounted: function() {

  }
};
</script>


<style>
.margin-bot {
  margin-bottom: 30px !important;
}
</style>